import { createAction, props } from '@ngrx/store';

import { AffordabilityData, AmortizationReportData, PitiData } from '../../typings/calculator';

export const updatePITIMortgageTerm = createAction(
  '[Calculator] Update PITI Mortgage Term',
  props<{
    payload: {
      mortgageTerm: number;
    };
  }>()
);

export const updatePITICalculatorData = createAction(
  '[Calculator] Update PITI Calculator Data',
  props<{
    payload: {
      annualOwnersInsurance: number;
      annualPropertyTaxes: number;
      buyerName: string | null;
      downPayments: number;
      homePrice: number;
      interestRate: number;
    };
  }>()
);

export const savePITIReport = createAction(
  '[Calculator] Save PITI Report',
  props<{
    payload: {
      reportData: PitiData;
    };
  }>()
);

export const savePITIReportSuccess = createAction('[Calculator] Save PITI Report Success');

export const savePITIReportFailure = createAction(
  '[Calculator] Save PITI Report Failure',
  props<{ payload: { error: Error } }>()
);

export const updateAffordabilityMortgageTerm = createAction(
  '[Calculator] Update Affordability Mortgage Term',
  props<{
    payload: {
      mortgageTerm: number;
    };
  }>()
);

export const updateAffordabilityCalculatorData = createAction(
  '[Calculator] Update Affordability Calculator Data',
  props<{
    payload: {
      annualOwnersInsurance: number;
      annualPropertyTaxes: number;
      buyerName: string | null;
      downPayments: number;
      interestRate: number;
      monthlyPayments: number;
    };
  }>()
);

export const saveAffordabilityReport = createAction(
  '[Calculator] Save Affordability Report',
  props<{
    payload: {
      reportData: AffordabilityData;
    };
  }>()
);

export const saveAffordabilityReportSuccess = createAction('[Calculator] Save Affordability Report Success');

export const saveAffordabilityReportFailure = createAction(
  '[Calculator] Save Affordability Report Failure',
  props<{
    payload: {
      error: Error;
    };
  }>()
);

export const updateAmortizationMortgageTerm = createAction(
  '[Calculator] Update Amortization Mortgage Term',
  props<{
    payload: {
      mortgageTerm: number;
    };
  }>()
);

export const updateAmortizationCalculatorData = createAction(
  '[Calculator] Update Amortization Calculator Data',
  props<{
    payload: {
      amount: number;
      interestRate: number;
    };
  }>()
);

export const getAmortizationDataSuccess = createAction(
  '[Calculator] Get Amortization Data Success',
  props<{
    payload: {
      reportData: AmortizationReportData;
    };
  }>()
);

export const saveAmortizationReport = createAction(
  '[Calculator] Save Amortization Report',
  props<{
    payload: {
      reportData: AmortizationReportData;
    };
  }>()
);

export const saveAmortizationReportSuccess = createAction('[Calculator] Save Amortization Report Success');

export const saveAmortizationReportFailure = createAction(
  '[Calculator] Save Amortization Report Failure',
  props<{ payload: { error: Error } }>()
);
